export default {
  "login": "Rahulraifzb",
  "id": 46862628,
  "node_id": "MDQ6VXNlcjQ2ODYyNjI4",
  "avatar_url": "https://avatars.githubusercontent.com/u/46862628?v=4",
  "gravatar_id": "",
  "url": "https://api.github.com/users/Rahulraifzb",
  "html_url": "https://github.com/Rahulraifzb",
  "followers_url": "https://api.github.com/users/Rahulraifzb/followers",
  "following_url": "https://api.github.com/users/Rahulraifzb/following{/other_user}",
  "gists_url": "https://api.github.com/users/Rahulraifzb/gists{/gist_id}",
  "starred_url": "https://api.github.com/users/Rahulraifzb/starred{/owner}{/repo}",
  "subscriptions_url": "https://api.github.com/users/Rahulraifzb/subscriptions",
  "organizations_url": "https://api.github.com/users/Rahulraifzb/orgs",
  "repos_url": "https://api.github.com/users/Rahulraifzb/repos",
  "events_url": "https://api.github.com/users/Rahulraifzb/events{/privacy}",
  "received_events_url": "https://api.github.com/users/Rahulraifzb/received_events",
  "type": "User",
  "site_admin": false,
  "name": "Rahul rai",
  "company": "Infoventive",
  "blog": "infoventive.com",
  "location": "India",
  "email": null,
  "hireable": null,
  "bio": "Software Engineer at Infoventive",
  "twitter_username": "rahulraifzb",
  "public_repos": 3,
  "public_gists": 0,
  "followers": 0,
  "following": 2,
  "created_at": "2019-01-20T10:25:33Z",
  "updated_at": "2021-02-12T10:49:28Z"
}
